var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-zawgyi"},[_c('label',{staticClass:"tgl"},[_c('input',{ref:"fontChange",staticClass:"fontChange",attrs:{"type":"checkbox"}}),_c('span',{staticClass:"cb",attrs:{"data-un":"unicode","data-zg":"zawgyi"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }